import { jsxs as e, jsx as r } from "react/jsx-runtime";
import { E as d, S as m } from "./icons.types-0722eef5.js";
function v({ title: i, titleId: n, size: l, width: t, height: c, extended: a = !1, ...o }) {
  const s = a ? d : m, h = l ? s[l] : t || s[a ? "s" : "l"], g = l ? s[l] : c || s[a ? "s" : "l"];
  return /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: h,
      height: g,
      "aria-labelledby": n,
      ...o,
      children: [
        i ? /* @__PURE__ */ r("title", { id: n, children: i }) : null,
        /* @__PURE__ */ r("g", { clipPath: "url(#Instagram_svg__a)", children: /* @__PURE__ */ r(
          "path",
          {
            fill: "currentColor",
            d: "M21.09.252c-3.83.18-6.446.792-8.733 1.69-2.366.923-4.372 2.16-6.368 4.163-1.996 2.003-3.225 4.01-4.14 6.381C.961 14.778.36 17.396.191 21.228c-.169 3.833-.206 5.065-.188 14.84.02 9.777.062 11.003.248 14.843.183 3.83.792 6.445 1.69 8.732.924 2.367 2.16 4.372 4.164 6.368 2.004 1.997 4.01 3.223 6.386 4.14 2.29.885 4.908 1.489 8.74 1.657 3.832.167 5.065.206 14.839.188 9.773-.02 11.003-.063 14.843-.245s6.441-.795 8.73-1.69c2.366-.925 4.373-2.16 6.368-4.164 1.995-2.004 3.223-4.013 4.138-6.385.887-2.29 1.49-4.908 1.656-8.737.168-3.843.208-5.07.189-14.844-.019-9.775-.063-11-.245-14.84-.182-3.839-.792-6.446-1.69-8.735-.925-2.366-2.16-4.37-4.163-6.368-2.003-1.998-4.013-3.226-6.384-4.139-2.29-.886-4.908-1.49-8.74-1.656-3.832-.165-5.065-.208-14.842-.189-9.777.019-11 .06-14.84.248Zm.42 65.08c-3.51-.153-5.415-.737-6.685-1.225-1.682-.648-2.88-1.431-4.146-2.685-1.266-1.253-2.043-2.456-2.7-4.134-.493-1.27-1.087-3.174-1.251-6.684-.179-3.793-.216-4.932-.237-14.544-.021-9.611.016-10.749.182-14.544.15-3.507.737-5.415 1.224-6.684.648-1.684 1.428-2.88 2.685-4.145 1.256-1.265 2.455-2.044 4.135-2.701 1.268-.495 3.172-1.084 6.68-1.251 3.797-.18 4.935-.216 14.545-.237 9.61-.021 10.75.015 14.548.182 3.507.153 5.416.734 6.684 1.224 1.682.648 2.88 1.426 4.145 2.685 1.265 1.258 2.045 2.453 2.701 4.136.496 1.265 1.085 3.168 1.25 6.679.182 3.797.223 4.935.24 14.544.017 9.61-.017 10.75-.183 14.544-.153 3.51-.735 5.416-1.224 6.688-.648 1.681-1.43 2.88-2.686 4.144-1.257 1.265-2.455 2.044-4.135 2.7-1.267.495-3.173 1.085-6.679 1.252-3.797.179-4.934.216-14.547.237-9.614.021-10.748-.018-14.544-.182M50.859 16.76a4.32 4.32 0 1 0 8.638-.014 4.32 4.32 0 0 0-8.638.014ZM17.516 36.036c.02 10.21 8.311 18.467 18.519 18.448 10.207-.02 18.47-8.31 18.451-18.52-.02-10.21-8.313-18.47-18.522-18.45-10.209.02-18.468 8.314-18.448 18.522ZM24 36.023a12 12 0 1 1 24-.048 12 12 0 0 1-24 .048Z"
          }
        ) }),
        /* @__PURE__ */ r("defs", { children: /* @__PURE__ */ r("clipPath", { id: "Instagram_svg__a", children: /* @__PURE__ */ r(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  v as Instagram
};
